import toDate from '../to-date';

export const getHours = (date: Date | number): number => {
  const formattedDate = toDate(date);

  const hours = formattedDate.getHours();

  return hours;
};

export default getHours;
